import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useRef } from 'react';
import { FeedbackWizard } from '@/features/wizard/components/FeedbackWizard';

export const Route = createFileRoute('/_dashboard/interactions/FeedbackWizard')(
  {
    component: RouteComponent,
    validateSearch: (search) => {
      return {
        employeeId: search.employeeId as string | undefined,
        interactionId: search.interactionId as string | undefined,
      };
    },
  }
);

function RouteComponent() {
  const search = useSearch({ from: Route.id });
  const clearedEmployeeIdRef = useRef<string | undefined>(undefined);

  // Clear session storage if a new employeeId is provided (override existing wizard state)
  // This ensures we start fresh with the new employee, resetting any previous form data
  // Clear synchronously on first render to ensure it happens before wizard service is created
  if (search.employeeId && clearedEmployeeIdRef.current !== search.employeeId) {
    const wizardFlowId = 'feedback-questions-wizard';
    // Always clear session storage when a new employeeId is provided
    // This resets the form and starts fresh with just the new employee selected
    sessionStorage.removeItem(wizardFlowId);
    clearedEmployeeIdRef.current = search.employeeId;
  }

  return (
    <FeedbackWizard
      initialEmployeeId={search.employeeId}
      existingInteractionId={search.interactionId}
    />
  );
}

/* 
This feedback wizard demo showcases:
- Enhanced WizardRangeStep with negative feedback colors
- Reused components from praise wizard where appropriate
- Dynamic routing based on feedback type selection
- Comprehensive negative feedback collection flow
- Structured data output for backend integration
*/
